import { useTranslation } from "react-i18next";

import { ReactComponent as DashboardIcon } from "assets/icons/menu/dashboard.svg";
import { ReactComponent as TasksIcon } from "assets/icons/menu/tasks.svg";
import { ReactComponent as NotificationIcon } from "assets/icons/menu/notification.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/menu/settings.svg";

const WebmasterMenu = (unreaded_count) => {
  const { t } = useTranslation();

  const menu_items = [
    {
      icon: <DashboardIcon />,
      label: t("Dashboard"),
      href: "/",
    },
    {
      icon: <TasksIcon />,
      label: t("Tasks"),
      href: "/tasks",
    },
    {
      icon: <NotificationIcon />,
      label: t("Notifications"),
      href: "/notifications",
      count: unreaded_count,
    },
    {
      icon: <SettingsIcon />,
      label: t("Settings"),
      href: "/settings",
    },
  ];

  return menu_items;
};

export default WebmasterMenu;
